/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {Entity} from '@ion/core/src/types/entities';
import {SmartSearchCriteria} from '@ion/core/src/types/services';
import useSearchCriteria, {CriteriaTypes} from './useSearchCriteria';

interface UseSmartSearchCriteriaProps {
  globalGroupId: number;
  viewSubGroups: boolean;
  entity: Entity;
  queryString: string;
}

/**
 * Re-usable hook that properly memoizes the given variables to return a populated
 * smart search request criteria.
 */
export const useSmartSearchCriteria = ({
  globalGroupId,
  viewSubGroups,
  entity,
  queryString
}: UseSmartSearchCriteriaProps): SmartSearchCriteria => (
  useSearchCriteria({
    criteriaType : CriteriaTypes.SMART_SEARCH,
    globalGroupId,
    entity,
    viewSubGroups,
    queryString
  }) as SmartSearchCriteria
);

export default useSmartSearchCriteria;
